import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTotalSelectedProducts, isDependentProductSelected } from '../../product-picker/selectors/products';
import { createReservation, updateQuantities } from '../../../actions/reservation';
import { createLoadingSelector } from '../../../selectors/helpers';
import { getTotalSelectedItems, getProductErrors, getBundleErrors } from '../selectors/selected-items';
import Button from '@s/Button';
import { setDisplayConfigurationError } from '../actions/ticket-picker';
import { reservationActive } from '../../../selectors/reservation';
import { isKioskMode } from 'checkout/selectors/ui';
import { showBestAvailablePicker, numberSelectedBestAvailableSeats, showPyosPicker, getSectionPriceLevelsWithUnmetMinimums } from 'checkout/selectors/reserved-seating';
import { getPriceLevelsWithUnmetMinimums } from '../selectors/tickets';
import { addAlert } from '../../../actions/ui.js';
import Translation from '@s/Translation';

class CheckoutButton extends Component {

    buttonText = () => {
        if (this.props.isKioskMode) {
            return <Translation>{'checkout__checkout'}</Translation>;
        }
        if (this.props.showBestAvailablePicker) {
            return <Translation>{'checkout__find_seats'}</Translation>
        }
        return <Translation>{'checkout__proceed_to_checkout'}</Translation>;
    }

    disabled = () => {
        if (this.props.maintenanceMode) {
            return true;
        }
        if (this.props.showPyosPicker && this.props.pyosLoading) {
            return true;
        }
        if (!this.props.showBestAvailablePicker && !this.props.showPyosPicker && !this.props.selectedItems && !this.props.selectedProducts) {
            return true;
        }
        if (!!this.props.showBestAvailablePicker && this.props.numberSelectedBestAvailableSeats < 1) {
            return true;
        }
        if (this.props.showPyosPicker && (!this.props.ticketCount || +this.props.ticketCount < 1)) {
            return true;
        }
        if (this.props.showPyosPicker && this.props.loading) {
            return true;
        }
        if (!this.props.showBestAvailablePicker && this.dependentProductError()) {
            return true;
        }
        if (this.props.taggableCouponLoading) {
            return true;
        }
        return !!this.props.loading;
    }

    render() {
        const buttonClass = this.props.isKioskMode ? "button--primary button--large kiosk-footer__button--primary" : "button--primary button--large add-to-cart__button";
        return (
            <div className="add-to-cart">
                <Button
                    onClick={this.requestInventory}
                    className={buttonClass}
                    disabled={this.disabled()}
                    loading={this.props.showPyosPicker ? false : this.props.loading}
                >
                    {this.buttonText()}
                </Button>
            </div>
        );
    }

    dependentProductError = () => {
        return (((this.props.ticketCount < 1 || this.props.ticketCount === undefined) && (this.props.bundleCount < 1 || this.props.bundleCount === undefined)) &&
            (!this.props.selectedItems && this.props.selectedDependentProducts));
    };

    alertUnmetMin = (name, min) => {
        this.props.addAlert('checkout__must_purchase_n_tickets_to_pay_price', 'error', true, {name, min});
    }

    requestInventory = () => {

        let productsValid = Object.keys(this.props.productsWithErrors).length === 0;
        let bundlesValid = Object.keys(this.props.bundleProductsWithErrors).length === 0;

        // only checking this if pyos because other ticket pickers should only allow selecting valid quantities
        if (this.props.showPyosPicker) {
            if (this.props.sectionPriceLevelsWithUnmetMinimums.length) {
                this.props.sectionPriceLevelsWithUnmetMinimums.forEach(secLevel => {
                    this.alertUnmetMin(secLevel.name, secLevel.minimum_purchase_limit);
                });
                return false;
            }
            if (this.props.priceLevelsWithUnmetMinimums.length) {
                this.props.priceLevelsWithUnmetMinimums.forEach(lvl => {
                    this.alertUnmetMin(lvl.name, lvl.minimum_purchase_limit);
                });
                return false;
            }
        }

        if (!productsValid || !bundlesValid) {
            this.props.setDisplayConfigurationError(true);
            return false;
        } else {
            this.props.setDisplayConfigurationError(false);
        }

        if (!this.props.reservationActive) {
            this.props.createReservation();
        } else {
            this.props.updateQuantities();
        }
    };

}

const getReservationLoading = createLoadingSelector(["RESERVATION_CREATE", "RESERVATION_FETCH"]);
const mapStateToProps = (state, props) => {
    return {
        ticketCount: state.reservation.ticket_count,
        bundleCount: state.reservation.bundle_count,
        selectedItems: getTotalSelectedItems(state),
        selectedDependentProducts: isDependentProductSelected(state),
        selectedProducts: getTotalSelectedProducts(state),
        loading: getReservationLoading(state),
        productsWithErrors: getProductErrors(state),
        bundleProductsWithErrors: getBundleErrors(state),
        reservationActive: reservationActive(state),
        isKioskMode: isKioskMode(state),
        maintenanceMode: state.ui.maintenanceMode,
        showBestAvailablePicker: showBestAvailablePicker(state),
        showPyosPicker: showPyosPicker(state),
        pyosLoading: state.reservedSeating.pyosLoading,
        numberSelectedBestAvailableSeats: numberSelectedBestAvailableSeats(state),
        sectionPriceLevelsWithUnmetMinimums: getSectionPriceLevelsWithUnmetMinimums(state),
        priceLevelsWithUnmetMinimums: getPriceLevelsWithUnmetMinimums(state),
        taggableCouponLoading: state.couponTag.taggableCouponLoading,
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        createReservation,
        updateQuantities,
        setDisplayConfigurationError,
        addAlert,
    },
    dispatch);
}

CheckoutButton.propTypes = {

}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutButton)
